export enum Environment {
  DEVELOPMENT = 'DEVELOPMENT',
  PRODUCTION = 'PRODUCTION',
}

export enum TradeName {
  LOOKIERO = 'LOOKIERO',
  OUTFITTERY = 'OUTFITTERY',
}

export interface Configuration {
  assetsPath: string;
  commonAssetsPath: string;
  environment: Environment;
  facebookAppId: string;
  googleWebId: string;
  kameleoonApiKey: string;
  paymentAssetsPath: string;
  shopAssetsPath: string;
  stripeKey: string;
  stripeUKKey: string;
  tradename: TradeName;
  cdnPath: string;
  i18nCdnPath: string;
  host: string;
  factoringSnippetId: string;
}
